import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledWrapper = styled.div`
	height: 100%;
	transition: opacity 0.3s ease;
	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	height: 100%;
	padding-top: 49px;
	background-color: #111111;
	transition: opacity 0.3s ease;
	&.loading-enter {
		opacity: 0;
	}

	&.loading-enter-active,
	&.loading-enter-done,
	&.loading-exit {
		opacity: 1;
	}

	&.loading-exit-active {
		opacity: 0;
	}
`;

const StyledLayoutContainer = styled.div`
	display: grid;
	grid-template-columns: 80px 1fr;
	height: 100%;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledLeftContainer = styled.div`
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledMenuContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 37px;
	height: 548px;
	padding: 30px 0;
`;

const StyledMenuItemContainer = styled.div<{ $active?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 17px;
	cursor: pointer;

	&:hover {
		img,
		${TextLabel} {
			opacity: 1;
		}
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition: opacity 0.3s ease;
	}

	${TextLabel} {
		font-weight: 500;
		font-size: 12px;
		line-height: 14px;
		color: #ffffff;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition: opacity 0.3s ease;
	}
`;

const StyledExitButton = styled.img`
	width: 20px;
	height: 20px;
	margin-top: auto;
	user-select: none;
	opacity: 0.5;
	transition: opacity 0.3s ease;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

export {
	StyledContainer,
	StyledWrapper,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledIconContainer,
	StyledMenuContainer,
	StyledMenuItemContainer,
	StyledExitButton,
};
